import { PipeTransform, Pipe } from '@angular/core';
@Pipe({
  name: 'labelSection'
})
export class LabelSectionPipe implements PipeTransform {

  constructor() { }

  transform(v: string): string {
    let result: string;
    switch (v) {
      case "customer":
        result = "Data Diri"
        break;
      case "venue":
        result = "Penilaian Resto"
        break;
      case "product":
        result = "Product"
        break;
      case "questionnaire":
        result = "Pertanyaan Tambahan"
        break;
      default:
        result = v
        break;
    }
    return result;
  }
}
